import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Modal from 'components/Modal';

const ProvideFeedback = ({ show, closeModal, openSubmitFeedback }) => {
  const openFeedbackDropdown = useCallback(() => {
    closeModal();
    openSubmitFeedback();
  }, [closeModal, openSubmitFeedback]);

  const closeModalHandler = useCallback(
    (e) => {
      if (e.target === e.currentTarget) closeModal();
    },
    [closeModal],
  );

  return (
    <Modal
      show={show}
      toggleModal={closeModalHandler}
      contentProps={{ className: 'center' }}>
      <img
        src="/assets/img/puzzle-piece-1.png"
        alt="provide-feedback"
        width="105px"
        style={{ marginBottom: 24 }}
      />
      <h3 style={{ fontSize: 24, marginTop: 0, marginBottom: 0 }}>
        Tell us what you think
      </h3>
      <p style={{ fontSize: 14, color: '#110830' }}>
        Please help us make ruttl better by providing us feedback on your
        experience reviewing a website.
      </p>
      <div>
        <Button
          type="button"
          styled
          invert
          grey
          style={{
            padding: '14px 34px',
            marginRight: 15,
          }}
          onClick={closeModal}>
          No Thanks
        </Button>
        <Button
          type="button"
          styled
          style={{ padding: '14px 34px' }}
          onClick={openFeedbackDropdown}>
          Happy to help!
        </Button>
      </div>
    </Modal>
  );
};

ProvideFeedback.propTypes = {
  show: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  openSubmitFeedback: PropTypes.func.isRequired,
};

export default ProvideFeedback;
